import {
  FundacaoLogo,
  FundacaoLogoTheme,
} from 'plataforma-fundacao-componentes';
import BackgroundImage from './backgroundImage/BackgroundImage';
import style from './SideImage.scss';
import Triangle from './triangle/Triangle';
const { rootClassName } = style;
export default function SideImage() {
  return (
    <div className={rootClassName}>
      <div className={`${rootClassName}-logo`}>
        <FundacaoLogo theme={FundacaoLogoTheme.Branco} width={130} />
      </div>
      <div className={`${rootClassName}-triangulo`}>
        <Triangle />
      </div>
      <div className={`${rootClassName}-background`}>
        <BackgroundImage />
      </div>
    </div>
  );
}
